import { TaskDefinition } from '../../graphql/schema';
import Illustration from '../base/Illustration';
import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { useNavigate } from 'react-router-dom';

interface Props {
  taskDefinition: Pick<
    TaskDefinition,
    'moduleId' | 'id' | 'categoryId' | 'title' | 'description' | 'illustration'
  >;
}

const SearchResultTile = ({ taskDefinition }: Props) => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    navigate(
      `/module/${taskDefinition.moduleId}/${taskDefinition.categoryId}/create/${taskDefinition.id}`,
    );
  }, [navigate, taskDefinition]);

  return (
    <div
      className="shadow relative group rounded-lg bg-white space-y-3 flex-col justify-between flex p-3 cursor-pointer hover:ring border-[#efefef] hover:ring-gray-300 w-[250px] shrink-0"
      onClick={handleClick}
    >
      <div className="flex flex-col space-y-1">
        <p className="text-sm font-semibold line-clamp-2">
          {taskDefinition.title}
        </p>

        <div className="text-gray-500 text-xs">
          {taskDefinition.description}
        </div>
      </div>

      <div className="flex flex-row justify-between items-end">
        <Illustration id={taskDefinition.illustration} className="w-[80px]" />
        <div className="group-hover:bg-[var(--theme-primary)] group-hover:text-[var(--theme-primary-text)] bg-gray-100 flex justify-center items-center rounded-full w-[30px] h-[30px]">
          <FontAwesomeIcon icon={faChevronRight} size="sm" />
        </div>
      </div>
    </div>
  );
};

export default SearchResultTile;
